module.exports = __webpack_public_path__ + "img/milmir.a34d09c7.jpg";